import React from 'react';

import { IconWrapper, Wrapper } from './styled';

type Props = {
  icon: JSX.Element;
  title: string;
  active?: boolean;
};
const MenuItem = ({ icon, title, active = false }: Props): JSX.Element => {
  return (
    <Wrapper $isActive={active} data-testid="sideMenuItem">
      <IconWrapper>{icon}</IconWrapper>
      <span>{title}</span>
    </Wrapper>
  );
};

export default MenuItem;
